import cx from 'classnames';
import {useCallback} from 'react';
import {VariantType} from '~/GalleryPB/types/template';
import {Toggle} from '~library/atoms/Toggle';

import './FreePremiumToggle.sass';

type FreePremiumToggleProps = {
  setVariant: (value: VariantType) => void;
  variant: VariantType;
};

export const FreePremiumToggle = ({setVariant, variant}: FreePremiumToggleProps) => {
  const onChangeHandler = useCallback(
    (value: unknown) => setVariant(value as VariantType),
    [setVariant]
  );

  return (
    <div className="quick-view__toggle__wrapper">
      <Toggle
        dataImpressionTracking
        options={[
          {
            label: 'Premium',
            value: VariantType.PREMIUM,
            dataQaId: 'toggle-premium',
            className: cx('quick-view__toggle', {
              'quick-view__toggle--selected': variant === VariantType.PREMIUM,
            }),
          },
          {
            label: 'Free',
            value: VariantType.FREE,
            dataQaId: 'toggle-free',
            className: cx('quick-view__toggle', 'quick-view__toggle--free', {
              'quick-view__toggle--selected': variant === VariantType.FREE,
            }),
          },
        ]}
        onChange={onChangeHandler}
        className="quick-view__content__toggle"
      />
    </div>
  );
};
